import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { useQuery } from '@moonpig/web-core-graphql'
import { useProductStore } from '../../contexts/product'
import { ModuleContext, ModuleUpsell } from '../types'
import { ProductUpsell } from '../../components/ProductUpsell'
import { getGiftUpsellProductId } from '../../utils/giftUpsellProductIds'
import {
  GetUpsellProductGQL,
  GetUpsellProductQuery,
  GetUpsellProductQueryVariables,
} from '../../queries/getUpsellProduct'

type Props = {
  context: ModuleContext
  module: ModuleUpsell
}

export const UpsellModule: FC<Props> = () => {
  const [{ product, variant }, dispatcher] = useProductStore()

  const giftUpsellProductId = getGiftUpsellProductId(product.id)

  const { data: upsellProductData } = useQuery<
    GetUpsellProductQuery,
    GetUpsellProductQueryVariables
  >(GetUpsellProductGQL, {
    variables: {
      productId: giftUpsellProductId as string,
    },
    skip: !giftUpsellProductId,
  })

  const upsellProduct = upsellProductData?.productLookup?.products[0]

  return upsellProduct && upsellProduct.masterVariant.inStock ? (
    <Box data-testid="module-upsell" mb={6}>
      <ProductUpsell
        upsellProduct={upsellProduct}
        selectedVariantPrice={variant.price}
        onClick={event => {
          event.preventDefault()
          dispatcher.setProduct(upsellProduct)
        }}
        trackingData={{
          pageLocation: 'product details',
          product: { id: product.id },
        }}
      />
    </Box>
  ) : null
}
